var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout",class:{ 'safe-area': _vm.safeArea },style:({ height: '100%' })},[_c('div',{staticClass:"app-main"},[_c('keep-alive',[_c('router-view')],1)],1),_vm._v(" "),(_vm.showNav)?_c('Nav'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }